import { render, staticRenderFns } from "./DisableUserModal.vue?vue&type=template&id=5f18ba34&"
import script from "./DisableUserModal.vue?vue&type=script&lang=js&"
export * from "./DisableUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports